import { useEffect, useRef } from 'react';

const SelectFormInput = ({
  children,
  multiple,
  className,
  onChange,
  value,
  defaultValue,
  disabled = false,
  searchEnabled,
  'data-search-enabled': dataSearchEnabled,
  ...choiceOptions
}) => {
  const selectE = useRef(null);
  const choicesInstanceRef = useRef(null);
  const enableSearch =
    searchEnabled !== undefined
      ? Boolean(searchEnabled)
      : dataSearchEnabled === undefined
        ? undefined
        : dataSearchEnabled === true || dataSearchEnabled === 'true';

  useEffect(() => {
    if (!selectE.current) return undefined;
    let cancelled = false;
    import('choices.js').then((mod) => {
      if (cancelled || !selectE.current) return;
      const Choices = mod.default || mod;
      const choices = new Choices(selectE.current, {
        ...choiceOptions,
        ...(enableSearch !== undefined ? { searchEnabled: enableSearch } : {}),
        allowHTML: true,
        shouldSort: false
      });
      choicesInstanceRef.current = choices;
      if (disabled && typeof choices.disable === 'function') {
        choices.disable();
      }

      const handleChange = (event) => {
        if (onChange) {
          const selectedValue = choices.getValue(true);
          if (selectedValue) {
            onChange(Array.isArray(selectedValue) ? selectedValue[0] : selectedValue);
          } else {
            const target = event.detail ? event.detail.passedElement.element : event.target;
            if (target && target.value !== undefined) {
              onChange(target.value);
            }
          }
        }
      };

      choices.passedElement.element.addEventListener('choice', handleChange);
      choices.passedElement.element.addEventListener('change', handleChange);
    }).catch(() => {});
    return () => {
      cancelled = true;
      if (choicesInstanceRef.current) {
        choicesInstanceRef.current.destroy();
        choicesInstanceRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectE]);

  useEffect(() => {
    const choices = choicesInstanceRef.current;
    if (!choices) return;
    if (disabled) {
      choices.disable?.();
    } else {
      choices.enable?.();
    }
  }, [disabled]);

  useEffect(() => {
    if (choicesInstanceRef.current && (value !== undefined || defaultValue !== undefined)) {
      const valueToSet = value !== undefined ? value : defaultValue;
      if (valueToSet !== undefined && valueToSet !== null) {
        choicesInstanceRef.current.setChoiceByValue(String(valueToSet));
      }
    }
  }, [value, defaultValue]);

  return (
    <select
      ref={selectE}
      multiple={multiple}
      className={className}
      defaultValue={defaultValue}
      value={value}
      disabled={disabled}
    >
      {children}
    </select>
  );
};

export default SelectFormInput;
